exports.data = [
	{
		tab: "Ph.D.",
		role: "Ph.D.",
		institute: "ASU",
		instituteLink: "https://www.asu.edu/",
		date: "Aug 2022 - Present",
		description: [
			"Pursuing Ph.D. at the department of Computer Science, SCAI, ASU",
			"CGPA - 3.97 out of 4.00.",
			"Working in the SHaDE Lab under the supervision of Dr. Ariane Middel",
			"Working in projects in the intersection of Accessibiliy, HCI, and Urban Climate"
		],
	},
	{
		tab: "M.Sc.",
		role: "M.Sc.",
		institute: "ASU",
		instituteLink: "https://www.asu.edu/",
		date: "Aug 2022 - April 2026",
		description: [
			"Passed Ph.D. comphreshensive exam and earned a Master's degree in Computer Science",
			"CGPA - 3.97 out of 4.00.",
		],
	},
	{
		tab: "B.Sc.",
		role: "B.Sc.",
		institute: "BUET",
		instituteLink: "https://www.buet.ac.bd/",
		date: "Feb 2016 - Feb 2021",
		description: [
			"Completed my undergrad from Bangladesh University of Engineering and Technology (BUET).",
			"Completed 160 credit hours.",
			"CGPA - 3.07 out of 4.00.",
			"Did my thesis on 'Knowledge Graph Generation from Program Source Code for Semantic Representation'.",
		],
	},
];
